export enum DeployedEnv {
  UNKNOWN = 'unknown',
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'test',
  STAGE = 'stage',
  PROD = 'prod',
}

export type CommerceEnv = 'dev' | 'int' | 'uat' | 'prod'

export type EnvHostInfo = {
  commerceEnv: CommerceEnv
  [brand: string]: string
}

export type EnvApiKeyInfo = {
  commerceEnv: CommerceEnv
  keys: {
    [brand: string]: Record<string, string>
  }
}

export type FeatureConfig = {
  disableStrictSSNValidation?: boolean
  disableAuthTokenSessionIdCheck?: boolean
  disableInsuranceToggleMessages?: boolean
  validateInsurerEligibleProduct?: boolean
}

export type HostInfo = {
  apiHost: EnvHostInfo
  apiKey: EnvApiKeyInfo
  feature?: FeatureConfig
  env: DeployedEnv
}
